const RatingUpdateBadge = ({ item, content }) => {
  const { rating } = item || {};
  return (
    <>
      {rating && (
        <p className={`nowrap-item mb-0 paragraph-p3 light-80-text flex-centered ${content ? '' : 'opacity-5'}`}>
          <span
            className={`specific-right-margin-6 text-white d-inline-block circle-button-20 text-center rate-${rating?.split(' ')[0]?.toLowerCase()}`}
          >
            <span
              className={`d-inline-block-centered centered-${rating?.charAt(0) === 'Q' ? `${content ? '6' : '7'}` : `${content ? '4' : '5'}`} paragraph-p5`}
            >
              {rating?.charAt(0)}
            </span>
          </span>
          {rating}
        </p>
      )}
    </>
  );
};

export default RatingUpdateBadge;
